import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  descriptorExist: true,
  descriptorComplete: true,
  menssege: "",
  divisions: [],
  descriptor: null,
};

export default function descriptorValidationReducer(
  state = initialData,
  action
) {
  switch (action.type) {
    case actions.LOADING_DESCRIPTOR_VALIDATION:
      return { ...state, loading: action.payload };
    case actions.DESCRIPTOR_VALIDATION:
      return {
        ...state,
        descriptorExist: action.payload.descriptorExist,
        descriptorComplete: action.payload.descriptorComplete,
        menssege: action.payload.menssege,
        divisions: action.payload.divisions,
        descriptor: action.payload.descriptor,
      };
    default:
      return state;
  }
}
